import React from 'react';
import { TWCPage } from '@components';
import { useRecoilState, useRecoilValue } from 'recoil';

import { currentWeatherConditionsPageTestIDs } from '@constants';
import { useWeatherAlerts } from '@hooks';
import { currentLocationWeatherState, screenReaderEnabledState } from '@store';

import { CurrentWeatherConditionsPageContent } from './CurrentWeatherConditionsPageContent/CurrentWeatherConditionsPageContent';

const childIds = [
  currentWeatherConditionsPageTestIDs.currentWeatherTopRow,
  currentWeatherConditionsPageTestIDs.currentWeatherConditionsWidget,
  currentWeatherConditionsPageTestIDs.weatherAlertsHeaderFrame,
  currentWeatherConditionsPageTestIDs.alertTilesList,
];

export const CurrentWeatherConditionsPage = () => {
  const alerts = useWeatherAlerts();
  const [screenReaderEnabled] = useRecoilState(screenReaderEnabledState);

  const { data: currentLocationWeatherData, error, isLoading } = useRecoilValue(currentLocationWeatherState);

  const firstFocus = screenReaderEnabled
    ? currentWeatherConditionsPageTestIDs.currentWeatherTopRow
    : currentWeatherConditionsPageTestIDs.currentWeatherConditionsWidget;

  return (
    <TWCPage
      childIds={childIds}
      firstFocus={firstFocus}
      isMenuItem={false}
      pageID={currentWeatherConditionsPageTestIDs.currentWeatherConditionsPage}
    >
      <CurrentWeatherConditionsPageContent
        alerts={alerts}
        currentLocationWeatherData={currentLocationWeatherData}
        error={error}
        isLoading={isLoading}
      />
    </TWCPage>
  );
};
